import omit from "lodash/omit";

import {
  LOGIN_FAILED,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGOUT_START,
  LOGOUT_SUCCESS
} from "./constants";

const initialState = {
  loading: false,
  loggedIn: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        loading: true
      };
    case LOGIN_SUCCESS:
      return omit(
        {
          ...state,
          ...action.user,
          loggedIn: true,
          loading: false
        },
        ["error", "errorDescription"]
      );
    case LOGIN_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        loggedIn: false,
        loading: false
      };
    case LOGOUT_START:
      return {
        ...state,
        loading: true
      };
    case LOGOUT_SUCCESS:
      return omit(
        {
          ...state,
          loading: false,
          loggedIn: false
        },
        "username"
      );
    default:
      return state;
  }
};

export { userReducer };

export default userReducer;
